import React, { createContext } from 'react';
import Cookies from 'js-cookie';
import Hotjar from '@hotjar/browser';

interface IAnalyticsContext {
  getRecentCampaignId: () => string|null;
  clearRecentCampaign: () => void;
  sendHotjarEvent: (eventName: string) => void;
}

const useQuery = () => {
  if(!window?.location?.search) {
    return new URLSearchParams();
  }

  return React.useMemo(() => new URLSearchParams( window.location.search ), [window.location.search]);
};


export const AnalyticsContext = createContext<Partial<IAnalyticsContext>>({});

export const AnalyticsContextProvider = ({ children }):JSX.Element => {
  const query = useQuery();

  if(query.has('utm_source')) {
    Cookies.set('recent_campaign', query.toString());
  }

  const getRecentCampaignId = ():string|null => {
    const cookieVal = Cookies.get('recent_campaign');
    if(!cookieVal) {
      return null;
    }
    const campaign = new URLSearchParams(cookieVal);
    return `${campaign.get('utm_source')}||${campaign.get('utm_term')}`;
  };

  const clearRecentCampaign = ():void => {
    if(!Cookies.get('recent_campaign')) {
      return;
    }
    Cookies.remove('recent_campaign');
  };

  const sendHotjarEvent = (eventName: string): void => {
    if(HOTJAR_SITE_ID) {
      Hotjar.event(eventName);
    }
  };

  return (
    <AnalyticsContext.Provider value={{
      getRecentCampaignId,
      clearRecentCampaign,
      sendHotjarEvent,
    }}>
      {children}
    </AnalyticsContext.Provider>
  );
};
